const IFRAME_URL =
  'https://decagon.ai/demo/masterclass?defaultVisibility=hidden'

export const getDecagoniFrame = () =>
  document.querySelector(`iframe[src="${IFRAME_URL}"]`) as HTMLElement
